import { render } from "./DataScreen.vue?vue&type=template&id=436ddd49"
import script from "./DataScreen.vue?vue&type=script&lang=js"
export * from "./DataScreen.vue?vue&type=script&lang=js"

import exportComponent from "/Users/peterdevos/Sites/tech_touch_aethon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__